export type Pod = {
  agency_id: string
  created_at: string
  id: string
  managers: {
    firstName: string
    lastName: string
    guidID: string
  }[]
  name: string
  updated_at: string
}

export const MAX_AGENCY_PODS = 12
export const MAX_POD_TEAM_MEMBERS = 30
